import { render, staticRenderFns } from "./EditPasswordForm.vue?vue&type=template&id=416c857c&"
import script from "./EditPasswordForm.vue?vue&type=script&lang=js&"
export * from "./EditPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports